/* eslint-disable no-useless-escape */
import { useEffect, useState, useCallback } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Select } from "components/core";
import { PageWrapper } from "components";
import { useGlobalContext } from "context/GlobalContext";
import { withLoader } from "HOC";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import PersonPinCircleIcon from "@material-ui/icons/PersonPinCircle";
import Divider from "@material-ui/core/Divider";
import { useParams, useHistory } from "react-router-dom";
import { CONFIRMED_ASSISTANCE } from "constants/index";
import { fetchBackend, orderByDes } from "helpers";
import { Modal } from "antd";

// const notificationMetadata = {
//   dateCreated: "",
//   title: "Has sido seleccionado para escoger su cita de vacunación",
//   description:
//     "Dirigete a la app de mexico seguro para continuar con el registro.",
//   type: "NOTIFICATION_TYPE_SYSTEM",
//   user: "",
// };

const SingleVaccine = ({ setLoading }) => {
  const [currentStep, setStep] = useState(1);
  const [currentVaccine, setVaccine] = useState(false);
  const [vaccineCenters, setVaccineCenters] = useState([]);
  const [currentCenter, setCenter] = useState(null);
  const gContext = useGlobalContext();
  const { id } = useParams();

  const getVaccineCenters = useCallback(async () => {
    const { error, response } = await fetchBackend({ url: "vaccineCenter" });
    if (!error) {
      setVaccineCenters(response);
      console.log(response);
    } else {
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar obtener los centros de vacunación, revisa tu conexión a internet",
        type: "error",
      });
    }
  }, []);

  const getVaccine = useCallback(async () => {
    const { error, response } = await fetchBackend({
      url: `vaccine/${id}`,
    });

    if (!error) {
      console.log(response);
      // setCompletedForm(response.length > 0);
      setVaccine(response[0]);
    } else {
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar obtener la información, revisa tu conexión a internet",
        type: "error",
      });
    }
  }, [id]);

  const getInitialState = useCallback(async () => {
    if (id) {
      await Promise.all([getVaccine(), getVaccineCenters()]);
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    getInitialState();
  }, []);

  // console.log(currentVaccine);
  // console.log(vaccineCenters);
  // console.log(currentCenter);

  return (
    <PageWrapper
      isBack={currentStep === 1}
      header={
        <Row start="xs">
          <Col md={12}>
            <Row center="xs">
              <h1>
                {currentStep === 1
                  ? "Programa de vacunación"
                  : "Horarios del centro de vacunación"}
              </h1>
            </Row>
          </Col>
        </Row>
      }
    >
      <Col md={12}>
        <SelectSchedule
          currentVaccine={currentVaccine}
          vaccineCenters={vaccineCenters}
          setStep={setStep}
          setCenter={setCenter}
          currentStep={currentStep}
        />
        <ListSchedules
          currentVaccine={currentVaccine}
          vaccineCenters={vaccineCenters}
          currentCenter={currentCenter}
          setStep={setStep}
          setCenter={setCenter}
          currentStep={currentStep}
        />
      </Col>
    </PageWrapper>
  );
};

export default withLoader(SingleVaccine, "Cargando detalles de registro");

const SelectSchedule = ({
  currentVaccine,
  setStep,
  setCenter,
  currentStep,
  vaccineCenters,
}) => {
  if (currentStep !== 1) return null;

  const onSelectCenter = (center) => {
    setCenter(center);
    setStep((s) => s + 1);
  };

  return (
    <Row>
      <Col md={12}>
        <ListVaccineCenters data={vaccineCenters} onClick={onSelectCenter} />
      </Col>
    </Row>
  );
};

const ListVaccineCenters = ({ data, onClick }) => {
  return (
    <List>
      {data.map((item) => {
        const { _id, title, direction, coordinates } = item;
        const linkMap = `https://maps.google.com/?q=${coordinates.latitude},${coordinates.longitude}`;
        return (
          <SingleNotification
            key={_id}
            title={title}
            linkMap={linkMap}
            description={direction}
            onClick={() => onClick(item)}
          />
        );
      })}
    </List>
  );
};

const SingleNotification = ({ title, description, linkMap, onClick }) => {
  return (
    <>
      <ListItem alignItems="flex-start" button onClick={onClick}>
        <ListItemText
          primary={title}
          secondary={
            <>
              <Typography component="span" variant="body2" color="textPrimary">
                {description}
              </Typography>
            </>
          }
        />
        <ListItemSecondaryAction>
          <IconButton edge="end" aria-label="delete">
            <a href={linkMap} target="_blank" rel="noreferrer">
              <PersonPinCircleIcon />
            </a>
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
      <Divider variant="inset" component="li" />
    </>
  );
};

const ListSchedules = ({ currentStep, currentCenter, state }) => {
  const [schedules, setSchedules] = useState([]);
  const gContext = useGlobalContext();
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    const getVaccineCenters = async (idVaccineCenter) => {
      const { error, response } = await fetchBackend({
        url: `vaccineCenterCalendar/vaccineCenter/${idVaccineCenter}`,
      });
      if (!error) {
        orderByDes(response, "date");
        setSchedules(response);
        console.log(response);
      } else {
        gContext.toggleAlert({
          message:
            "Hubo un error al intentar obtener los centros de vacunación, revisa tu conexión a internet",
          type: "error",
        });
      }
    };
    currentCenter?._id && getVaccineCenters(currentCenter?._id);
  }, [currentCenter]);

  const addEventToGoogleCalendarByCompany = useCallback(async (metadata) => {
    const { error, response } = await fetchBackend({
      method: "post",
      url: `googleCalendar`,
      data: metadata,
    });

    if (!error) {
      console.log("metadata", metadata);
      console.log(response);
    } else {
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar agregar el evento al calendario, revisa tu conexión a internet",
        type: "error",
      });
    }
  }, []);

  const updateQuoterCenterCalendar = useCallback(
    async (idCalendar, idQuote) => {
      const { error, response } = await fetchBackend({
        method: "put",
        url: `vaccineCenterCalendar/${idQuote}/calendar/${idCalendar}`,
        data: { isAvailable: false },
      });

      if (!error) {
        console.log("idCalendar", idCalendar);
        console.log("idQuote", idQuote);
        console.log(response);
      } else {
        gContext.toggleAlert({
          message:
            "Hubo un error al intentar obtener actualizar los datos, revisa tu conexión a internet",
          type: "error",
        });
      }
    },
    []
  );

  const updateVaccine = async (newObj) => {
    const { error, response } = await fetchBackend({
      method: "put",
      url: `vaccine/${id}`,
      data: newObj,
    });

    if (!error) {
      console.log(response);
    } else {
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar actualizar el usuario, revisa la información",
        type: "error",
      });
    }
  };

  //   const addNotificationToSystem = async () => {
  //     const dbNotification = {
  //       ...notificationMetadata,
  //       dateCreated: new Date().getTime(),
  //       user: state?.user,
  //     };

  //     console.log(dbNotification);
  //     const { error, response } = await fetchBackend({
  //       method: "post",
  //       url: "notification",
  //       data: dbNotification,
  //     });

  //     if (!error) {
  //       console.log(response);
  //     } else {
  //       message.error(
  //         "Hubo un error al intentar agregar datos al sistema, revisa la información"
  //       );
  //     }
  //   };

  //   const getMetadataNotification = async () => {
  //     // get tokens devices for notifications
  //     const { error, response } = await getDocumentFirebaseDB(
  //       `/TOKENS/${state.user}/`
  //     );

  //     const messageData = {};

  //     if (!error) {
  //       messageData.data = {
  //         title: notificationMetadata.title,
  //         body: notificationMetadata.description,
  //       };
  //       messageData.token = Object.values(response);
  //     } else {
  //       message.error(
  //         "Hubo un error al intentar enviar la notificación a el usuario, revisa tu conexión  internet"
  //       );
  //     }

  //     return messageData;
  //   };

  //   const sendNotificationUser = async () => {
  //     const metadata = await getMetadataNotification();

  //     const response = await fetchBackend({
  //       method: "post",
  //       url: "firebaseMessaging",
  //       data: metadata,
  //     });

  //     console.log(response);
  //   };

  const onChange = (e, idQuote) => {
    const schedule = e.target.value;
    gContext.toggleModal({
      title: "¿Desea seleccionar este horario para la cita del usuario?",
      description:
        "Esta acción no se puede deshacer, a menor que el usuario no confirme su asistencia",
      okText: "Si, continuar",
      cancelText: "No, cancelar",
      onOk: async () => {
        const singleQuote = idQuote.calendar.find((el) => el._id === schedule);

        const hour = singleQuote?.hour;
        const date = `${new Date(1617004800323).toLocaleDateString()}, ${hour}`;
        const dateCalendar = new Date(date);

        const metaCalendar = {
          // eventId: "4ve1ih83ib199hdgbqsh1aah2g",
          summary: "Cita de vacunación COVID19 | México Seguro",
          location: currentCenter?.direction,
          description:
            "Recuerda llegar 45 minutos antes para agilizar la aplicación de la vacuna. Muchas gracias por su confianza.",
          attendees: [],
          // attendees: [{ email: "lpage@example.com" }, { email: "sbrin@example.com" }],
          dateTime: dateCalendar,
        };

        await addEventToGoogleCalendarByCompany(metaCalendar);
        await updateQuoterCenterCalendar(schedule, idQuote._id);
        await updateVaccine({
          status: CONFIRMED_ASSISTANCE,
          vaccinationPlace: {
            hour,
            idSchedule: schedule,
            idQuote: idQuote._id,
            VaccineCenter: currentCenter?._id,
            date: dateCalendar.getTime(),
          },
        });

        // await addNotificationToSystem();
        // await sendNotificationUser();
        gContext.toggleAlert({
          message: "Se ha actualizado los datos exitosamente",
        });
        gContext.toggleModal(null);
        setTimeout(() => history.push(`/vacunas/${id}`), 500);
      },
      onCancel: () => {
        gContext.toggleModal(null);
      },
    });
  };

  // console.log(currentStep);

  if (currentStep !== 2) return null;
  return (
    <Row>
      {schedules.map((item) => {
        return (
          <Select
            key={item._id}
            md={12}
            valueOption="_id"
            labelOption="hour"
            label={`Día ${new Date(
              item?.date
            ).toLocaleDateString()} - Horario: ${new Date(
              item?.hour.start
            ).toLocaleTimeString()} - ${new Date(
              item?.hour.end
            ).toLocaleTimeString()}`}
            placeholder="Selecciona un horario"
            options={(item?.calendar || []).filter((el) => el?.isAvailable)}
            defaultValue={[]}
            onChange={(e) => onChange(e, item)}
          />
        );
      })}
    </Row>
  );
};
